import React from 'react';
import { motion } from 'framer-motion';

const Reports = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-6"
    >
      <div>
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Reports</h1>
        <p className="text-gray-600">Analyze your business performance and insights</p>
      </div>
      
      <div className="bg-white rounded-xl p-8 shadow-soft text-center">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">Analytics & Reports</h3>
        <p className="text-gray-600">Reporting features will be implemented here</p>
      </div>
    </motion.div>
  );
};

export default Reports;